// @ts-nocheck

import TableOutlined from '@ant-design/icons/TableOutlined';
import ProfileOutlined from '@ant-design/icons/ProfileOutlined'

export default {
  TableOutlined,
ProfileOutlined
}
    